const ko_formatter = new Intl.NumberFormat('ko-KR');
const vi_formatter = new Intl.NumberFormat('vi-VN');

export function numberWithCommas(x, country = 'ko') {
  if (x === null || x === undefined || x === false || isNaN(x) || !isFinite(x)) {
    return '';
  }

  const number = parseFloat(x);

  if (country === 'ko') {
    return ko_formatter.format(number);
  } else {
    return vi_formatter.format(number);
  }
}

export function numberWithPercent(x, country = 'ko') {
  if (x === null || x === undefined || x === false || isNaN(x) || !isFinite(x)) {
    return '';
  }
  const number = parseFloat(x);

  if (country === 'ko') {
    return ko_formatter.format(number) + '%';
  } else {
    return vi_formatter.format(number) + '%';
  }
}

export function getUnit(country = 'ko') {
  return country === 'ko' ? '원' : 'đ';
}

export function numberUnitWithCommas(x, country = 'ko', isSpace = true) {
  if (x === null || x === undefined || x === false || isNaN(x) || !isFinite(x) || !country) {
    return '';
  }
  const number = parseFloat(x);
  const value = country === 'ko' ? ko_formatter.format(number) : vi_formatter.format(number);
  const unit = getUnit(country);
  return value + `${isSpace ? ' ' : ''}${unit}`;
}

export function formatBusinessNumber(num) {
  if (!num) return '';
  return num.toString().replace(/(\d{3})(\d{2})(\d+)/, '$1-$2-$3');
}
export function geKoreanNumber(number) {
  if (!number) return '';
  const koreanNumber = ['', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구'];
  const tenUnit = ['', '십', '백', '천'];
  const tenThousandUnit = ['해', '경', '조', '억', '만', ''];
  const unit = 10000;

  let answer = '';

  while (number > 0) {
    const mod = number % unit;
    const modToArray = mod.toString().split('');
    const length = modToArray.length - 1;

    const modToKorean = modToArray.reduce((acc, value, index) => {
      const valueToNumber = +value;
      if (!valueToNumber) return acc;
      // 단위가 십 이상인 '일'글자는 출력하지 않는다. ex) 일십 -> 십
      // const numberToKorean = index < length && valueToNumber === 1 ? '' : koreanNumber[valueToNumber];
      // return `${acc}${numberToKorean}${tenUnit[length - index]}`;
      return `${acc}${koreanNumber[valueToNumber]}${tenUnit[length - index]}`;
    }, '');
    if (answer === '만' || answer === '억' || answer === '조' || answer === '경') {
      answer = '';
    }
    answer = `${modToKorean}${tenThousandUnit.pop()}${answer}`;
    number = Math.floor(number / unit);
  }

  return answer.replace();
}

export function formatKoreanNumber(amount, country = 'ko') {
  if (amount === null || amount === undefined || amount === false || isNaN(amount)) {
    return '';
  }

  const absValue = Math.abs(amount);
  const sign = amount < 0 ? '-' : '';

  if (country === 'vi') {
    return `${sign}${absValue}đ`;
  }

  // 1억 이상인 경우
  if (absValue >= 100000000) {
    const eok = Math.floor(absValue / 100000000);
    const man = Math.floor((absValue % 100000000) / 10000);
    if (man > 0) {
      return `${sign}${ko_formatter.format(eok)}억 ${ko_formatter.format(man)}만원`;
    }
    return `${sign}${ko_formatter.format(eok)}억원`;
  }

  // 만원 이상 1억 미만인 경우
  if (absValue >= 10000) {
    const man = Math.floor(absValue / 10000);
    return `${sign}${ko_formatter.format(man)}만원`;
  }

  // 만원 미만인 경우
  return `${sign}${ko_formatter.format(absValue)}원`;
}

export function phoneFormat(phone) {
  if (!phone) return '';
  // phone을 모두 숫자로 바꾼다
  let onlyNumber = String(phone).replace(/\D/g, '');
  if (onlyNumber.length === 11) {
    // 3-4-4
    return onlyNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  } else if (onlyNumber.length === 10) {
    // 2-4-4
    return onlyNumber.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
  } else if (onlyNumber.length === 8) {
    // 8자리면 앞에 010을 붙이고 3-4-4로
    onlyNumber = '010' + onlyNumber;
    return onlyNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  } else {
    return onlyNumber;
  }
}
